import React from 'react';
import './Industries.css';
import FMSimage from '../Assets/indus2.jpeg'; // First image (full size)
import FMSimage2 from '../Assets/indus1.jpeg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/indus3.jpeg'; // Image for How it Works section
import FMSimage4 from '../Assets/indus4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/indus5.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">POWER MONITORING FOR VARIOUS FOOD GRADE INDUSTRIES</h1>
                    <p className="FMS-description">
                        The Power Monitoring Solution from Vajra IoT is an advanced system designed to provide precise energy usage monitoring and management for food-grade industries. This IoT-based platform enables real-time monitoring of energy consumption across multiple equipment and areas, helping businesses optimize their energy usage, reduce costs, and enhance operational efficiency.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Power Monitoring" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
                        <li><strong>Real-Time Monitoring:</strong> Tracks energy consumption across various devices and equipment, ensuring optimal performance.</li>
                        <li><strong>Cost Reduction:</strong> Helps identify high energy usage patterns, leading to cost-effective energy management strategies.</li>
                        <li><strong>Data-Driven Insights:</strong> Provides detailed energy usage reports, empowering businesses to make informed decisions.</li>
                        <li><strong>Remote Access:</strong> Enables users to monitor energy consumption from anywhere through a secure cloud platform.</li>
                        <li><strong>Seamless Integration:</strong> Easily integrates with existing energy management systems for enhanced functionality.</li>
                    </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Energy Monitoring Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
                        <li><strong>Centralized Monitoring:</strong> All energy consumption data is sent to a centralized platform for easy tracking.</li>
                        <li><strong>Instant Alerts:</strong> Notifies users immediately when energy consumption exceeds thresholds, prompting corrective actions.</li>
                        <li><strong>Integration with Smart Devices:</strong> The system integrates with smart meters and IoT-enabled devices for automated data collection and management.</li>
                        <li><strong>Comprehensive Analytics:</strong> The system analyzes energy trends and patterns to provide actionable insights for improved efficiency.</li>
                        <li><strong>Scalable Setup:</strong> Suitable for a variety of industries, from small-scale operations to large manufacturing plants.</li>
                    </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Power Monitoring Solution</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
                        <li><strong>Accurate Data:</strong> Provides precise energy consumption data for better decision-making and energy optimization.</li>
                        <li><strong>Enhanced Efficiency:</strong> Helps businesses reduce energy wastage and improve operational efficiency.</li>
                        <li><strong>Cost Savings:</strong> Reduces operational costs by identifying areas for energy conservation and optimization.</li>
                        <li><strong>Expert Support:</strong> Our team provides dedicated support to ensure the system runs efficiently and effectively.</li>
                    </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our Power Monitoring Solution */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our Power Monitoring Solution</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using Power Monitoring" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    Our Power Monitoring Solution is trusted by various industries to ensure efficient energy management and cost control. The following industries benefit from our system:
                    <ul>
                        <li>Food and Beverage Manufacturing</li>
                        <li>Pharmaceuticals</li>
                        <li>Packaging</li>
                        <li>Energy & Utilities</li>
                        <li>Smart Cities</li>
                    </ul>
                    </p>
                </div>
            </div>

        </div>
    );
};

export default FMS;
